window.shouldAllowRawHTMLMessages = false;

export default function () {
    return window.shouldAllowRawHTMLMessages;
}
